import { META_PIXEL_ID, PIXEL_DRY_RUN } from '../data/pixel';

type PixelEvent = 'PageView' | 'ViewContent' | 'InitiateCheckout';
type PixelParams = Record<string, unknown>;

type FbqStub = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqStub;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: FbqStub;
    _fbq?: FbqStub;
    /** Dry-run log: every event the page would send, to check the pixel without touching Meta */
    __pixelLog?: { event: PixelEvent; params?: PixelParams; at: number }[];
  }
}

let initialized = false;

function logDryRun(event: PixelEvent, params?: PixelParams) {
  window.__pixelLog = window.__pixelLog ?? [];
  window.__pixelLog.push({ event, params, at: Date.now() });
  // eslint-disable-next-line no-console
  console.info('[pixel dry run — not sent]', event, params ?? '');
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized || !META_PIXEL_ID) return;
  initialized = true;

  if (PIXEL_DRY_RUN) {
    logDryRun('PageView');
    return;
  }

  if (!window.fbq) {
    const stub = function (...args: unknown[]) {
      if (stub.callMethod) stub.callMethod(...args);
      else stub.queue.push(args);
    } as FbqStub;
    stub.push = stub;
    stub.loaded = true;
    stub.version = '2.0';
    stub.queue = [];
    window.fbq = stub;
    if (!window._fbq) window._fbq = stub;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

export function trackPixel(event: Exclude<PixelEvent, 'PageView'>, params?: PixelParams) {
  if (typeof window === 'undefined' || !META_PIXEL_ID) return;
  if (PIXEL_DRY_RUN) {
    logDryRun(event, params);
    return;
  }
  window.fbq?.('track', event, params);
}
